import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingSmsManagementDetailsAPI from '../apis/marketingSmsManagementDetailsAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingSmsManagementDetailsStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*SearchResult start*/
  @observable searchItem = {
    'taskGroupId': '',
    'isHistory:': 0,
    'respCode': '',
    'phone': '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingSmsManagementDetailsAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  //Status 下拉列表
  @observable statusList = []
  @action
  async onGetStatus(params) {
    this.statusList = []
    try {
      const response = await marketingSmsManagementDetailsAPI.getStatus(params)
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        if (code === 0) {
          this.statusList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'taskGroupId': this.searchItem.taskGroupId,
      'isHistory': this.searchItem.isHistory,
      'respCode': this.searchItem.respCode,
      'phone': this.searchItem.phone,
      'isPowerUser': this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }
}
